import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Info } from "lucide-react";
import AlarmDetailsModal from "../../components/MultimeterAlarmDetailsModal";

// BIT_LABELS removed, moved to translation.json

// Relay-1 için keyword eşleşmeleri
const RELAY1_FIELD_MAP = {
    0: ["Yüksek Akım"],
    1: ["Düşük Akım"],
    2: ["Yüksek Gerilim"],
    3: ["Düşük Gerilim"],
    4: ["Yüksek Frekans"],
    5: ["Düşük Frekans"],
    6: ["Gerilim Dengesizliği"],
    7: ["Akım Dengesizliği"],
    8: ["Genel Röle 1"],
    9: ["Genel Röle 1"],
    10: ["Faz Yokluğu"],
    11: ["Faz Sırası"],
    12: ["Başlatma Gecikmesi"],
    13: [], // Ani Akım → DETAY YOK
};

export default function MultimeterRelay1Alarms() {
    const { t } = useTranslation();
    const { deviceId } = useParams();
    const API_BASE = process.env.REACT_APP_API_BASE_URL;
    const NO_DETAIL_BITS = [8, 9, 12, 13];


    const [word1, setWord1] = useState(null);

    const [details, setDetails] = useState(null);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        async function fetchBits() {
            try {
                const res = await fetch(`${API_BASE}/multimeter/alarms?deviceId=${deviceId}`);
                const json = await res.json();
                setWord1(json.relay1.general);


            } catch (err) {
                console.error("relay1 bit fetch error:", err);
            }
        }

        fetchBits();
    }, [deviceId]);

    if (word1 === null)
        return <div className="p-6">{t('alarms.loading')}</div>;

    const getBit = (word, bit) => (word >> bit) & 1;

    const alarms = [];
    for (let i = 0; i <= 13; i++) {
        alarms.push({
            bit: i,
            name: t(`alarms.bitLabels.${i}`),
            active: getBit(word1, i) === 1,
        });
    }

    const openDetails = async (alarm) => {
        // Ani Akım → detay yok, modal açtırma
        if (alarm.bit === 13) return;

        try {
            const res = await fetch(
                `${API_BASE}/multimeter/alarms/relay1?deviceId=${deviceId}`
            );

            const json = await res.json();
            console.log(json)
            const keywords = RELAY1_FIELD_MAP[alarm.bit] || [];

            // İçeren description’ları çekiyoruz
            const filtered = Object.keys(json)
                .filter((desc) =>
                    keywords.some((kw) => desc.includes(kw))
                )
                .reduce((acc, key) => {
                    acc[key] = json[key];
                    return acc;
                }, {});

            setDetails({
                title: alarm.name,
                fields: Object.keys(filtered).map((k) => ({
                    key: k,
                    label: k,
                })),
            });

            setFormData(filtered);
        } catch (err) {
            console.error("relay1 detail fetch error:", err);
        }
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">{t('alarms.multimeterStatusTitle')}</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {alarms.map((a) => (
                    <div
                        key={a.bit}
                        className="bg-white shadow rounded-lg p-4 flex items-center justify-between"
                    >
                        <h2 className="text-lg font-semibold">{a.name}</h2>

                        <div className="flex items-center gap-3">
                            <span
                                className={`px-3 py-1 rounded-full text-sm font-bold ${a.active ? "bg-blue-500 text-white" : "bg-gray-300 text-gray-700"
                                    }`}
                            >
                                {a.active ? t('alarms.active').toUpperCase() : t('alarms.passive').toUpperCase()}
                            </span>

                            {!NO_DETAIL_BITS.includes(a.bit) ? (
                                <button
                                    onClick={() => openDetails(a)}
                                    className="p-2 rounded-full hover:bg-gray-100 text-gray-600"
                                >
                                    <Info className="w-5 h-5" />
                                </button>
                            ) : (
                                <div className="p-2 opacity-0">
                                    <Info className="w-5 h-5" />
                                </div>
                            )}
                        </div>

                    </div>
                ))}
            </div>

            {details && (
                <AlarmDetailsModal
                    alarm={details}
                    formData={formData}
                    onClose={() => setDetails(null)}
                />
            )}
        </div>
    );
}
